import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';
import shouldForwardProp from '@styled-system/should-forward-prop';

export interface BaseTextareaProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingInputKeys = WithoutCollidingProps<
  BaseTextareaProps,
  'textarea'
>;

export const Textarea = styled<'textarea', keyof NonCollidingInputKeys>(
  'textarea',
  {
    shouldForwardProp: (prop): prop is keyof NonCollidingInputKeys =>
      shouldForwardProp(prop as keyof NonCollidingInputKeys),
  }
)<BaseTextareaProps>(
  defineWithTheme('inputs'),
  compose(background, border, color, position, shadow, space, typography)
);

export type TextareaProps = React.ComponentPropsWithoutRef<typeof Textarea>;
